import { FormControl } from '@angular/forms';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { CustomLoadingService } from './../../shared/custom-loading/custom-loading.service';
import { ClaimService } from './../claim.service';
import { Component, OnInit } from '@angular/core';
import { MailingDialogComponent } from 'src/app/shared/mailing-dialog/mailing-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { startWith, debounceTime, tap, switchMap, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.css']
})
export class PatientsComponent implements OnInit {
  showAddClaim: any;
  showAddClaimMsg: any;
  searchTerm = new FormControl()
  users: any = []
  isSelected: any = false;
  title: any = "ClaimList"
  filteredUser: Observable<any[]>;
  constructor(private claimService: ClaimService, private appSettingService: AppSettingService,
    private loadingService: CustomLoadingService,
    public dialog: MatDialog, protected translateService: TranslateService) {
    if (this.appSettingService.loggedInUser.IsNetworkCoach == 'True') {
      this.showAddClaim = false;
    }
    else {
      this.showAddClaim = true;
    }
    this.filteredUser = this.searchTerm.valueChanges
      .pipe(
        startWith(''),
        debounceTime(500),
        tap(() => {
          //  this.loadService.show();
        }),
        switchMap(() => {
          if (typeof (this.searchTerm.value) == "object") {
            return []
          }
          return this.claimService.getPatients(this.searchTerm.value, 1).pipe(
            map(results => {
              //  this.loadService.hide();

              if (!this.isSelected) {
                if (results.length <= 0)
                  results.push({ "UserId": 0, FullName: this.translateService.instant("Common.PatientNotFound") });
                return results;
              } else {
                this.isSelected = false;

              }

            }
            ))
        }
        )
      )


  }


  displayFn(user: any): string {
    if (user != undefined && user.UserId == 0)
      return
    return user ? user.FullName : user;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MailingDialogComponent, {
      width: 'auto', data: {}
    });

    dialogRef.afterClosed().subscribe(() => {

      this.getUsers()
    });
  }

  ngOnInit(): void {
    var loggedInUser = this.appSettingService.loggedInUser

    if ((loggedInUser.FirstTimeLogin.toLowerCase() == "true") && loggedInUser.AdminLogin == undefined) {
      loggedInUser.FirstTimeLogin = "false";
      this.appSettingService.loggedInUser = loggedInUser
      this.openDialog();
    }
    else {
      this.getUsers()
    }

  }

  getUsers() {

    this.loadingService.show();
    this.claimService.getUsers(this.searchTerm).subscribe((res: any) => {
      if (res && res.length > 0) {
        this.users = res;
      }
      else {
        /*Added check for 1099 coach */
        if (this.appSettingService.loggedInUser.IsNetworkCoach == 'True') {
          this.showAddClaim = false;
        }
        else {
          this.showAddClaim = true;
        }
        this.showAddClaimMsg = "You have no recent claims history. Once you have a completed a coaching session, your claim information will be visible here.";
      }

    }, () => {

      this.loadingService.hide();

    }, () => {
      this.loadingService.hide();
    })

  }


}
